import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import logo from "../../assets/images/logo.png";
import { Label, Spinner, Alert } from "reactstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { useRef } from "react";
import { verifyCode } from "../../slices/auth/verifyCode/thunk";

const Banner = () => {
  return (
    <div className="banner">
      <div className="bannerContent">Drive Efficiency, Deliver Success</div>
    </div>
  );
};

const multifactorSchema = Yup.object().shape({
  otp: Yup.array()
    .of(Yup.string())
    .required("All 6 digits are required")
    .test("is-complete", "All 6 digits are required", function (value) {
      if (value && value.length === 6) {
        return value.every((obj) => obj !== undefined && obj.trim() !== "");
      }
      return false;
    }),
});

const initialValues = {
  otp: Array(6).fill(""),
};

const VerifyOtp = () => {
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState(null);
  const [alertMessage, setAlertMessage] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const loading = useSelector((state) => state.VerifyCode.loading);
  const verifyCodeError = useSelector(
    (state) => state.VerifyCode.verifyCodeError
  )


  const length = 6;
  const inputRefs = useRef([]);

  const queryParams = new URLSearchParams(location.search);
  const email = queryParams.get("email") || "";

  const formik = useFormik({
    initialValues,
    validationSchema: multifactorSchema,
    onSubmit: async (values) => {
   try {
       const otpCode = values.otp.join("");
       const newValues = {
         email: email,
         otp: parseInt(otpCode, 10),
         reset_password: false,
       };
 
       const res = await dispatch(verifyCode(newValues));
       if (res?.message) {
         setAlertType("success");
         setAlertMessage(res?.message);
         setShowAlert(true);
         setTimeout(() => {
           setShowAlert(false);
           navigate(
             `/reset-password?otp=${otpCode}&email=${email}`
           );
         }, 3000);
 
       } else {
         setAlertType("danger");
         setAlertMessage(verifyCodeError || "Verification failed. Please try again.");
         setShowAlert(true);
       }

   } catch (error) {
     console.log("error", error) 
    
   }
    },
  });

  const handleInputChange = (e, index) => {
    const { value } = e.target;
    const newValue = [...formik.values.otp];
    newValue[index] = value;
    formik.setFieldValue("otp", newValue);

    if (value && index < length - 1) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    const { key } = e;
    if (key === "Backspace" && !formik.values.otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };


  document.title = "Verify Code | D&A";

  return (
    <React.Fragment>
      <div className="loginPage">
        <Banner />
        <div className="loginWrapper">
          <div className="loginContent">
            {showAlert && (
              <Alert
                color={alertType}
                toggle={() => setShowAlert(false)}
                fade={true}
                className="mb-4"
              >
                {alertMessage}
              </Alert>

            )}
            <div className="headerText">
              <img
                loading="lazy"
                className="logoImage"
                src={logo}
                alt="Company logo"
              />
              <h1 className="welcomeBack">Verify OTP</h1>
              <p className="loginInstructions">
                Enter 6 Digit Verification Code, which mail to you
              </p>
            </div>
            <form
              className="loginForm"
              onSubmit={formik.handleSubmit}
              noValidate
            >
              <div className="inputField">
                <Label htmlFor="newPassword" className="inputLabel">
                  Enter Code
                </Label>

                <div className="d-flex flex-column gap-2">
                  <div className="d-flex gap-2">
                    {Array.from({ length }, (_, InputIndex) => (
                      <input
                        key={InputIndex}
                        type="text"
                        inputMode="numeric"
                        name={`otp-${InputIndex}`}
                        pattern="[0-9]*"
                        maxLength={1}
                        className="textInputCode"
                        value={formik.values.otp[InputIndex]}
                        onChange={(e) => handleInputChange(e, InputIndex)}
                        onKeyDown={(e) => handleKeyDown(e, InputIndex)}
                        ref={(el) => (inputRefs.current[InputIndex] = el)}
                        onInput={(e) => {
                          const input = e.target;
                          if (input.value.length > 1) {
                            input.value = input.value.slice(0, 1);
                          }
                        }}
                      />
                    ))}
                  </div>

                  {formik.touched.otp && formik.errors.otp && (
                    <div className="text-danger" style={{ fontSize: "14px", marginTop: "4px" }}>
                      {formik.errors.otp}
                    </div>
                  )}
                </div>

              </div>

              <button type="submit" className="signInButton">
                {loading ? <Spinner /> : "Verify Code"}
              </button>
              <div className="d-flex align-items-center mx-auto mt-4 gap-1">
                <div className="d-flex align-items-center mx-auto mt-4 gap-1">
                  <p
                    className="signUpPrompt cursor-pointer"
                    onClick={() => {
                      navigate("/login");
                    }}
                  >
                    Back to Login{" "}
                  </p>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default VerifyOtp;
